import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import BusquedaCtaContable from './busquedaCtaContable';
import global_axios from '../../funciones_globales/interaccionapi';
import { cargarAsiento } from '../../actions/contabilidad/act_con01';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearFechaMoment_a_String, completar_String } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso, validarJSON, esNumero, validarCampoString } from '../../funciones_globales/utils';
import { cargarCatalogos_OtrosConIndicador, cargarCatalogoEstados } from '../../funciones_globales/catalogos';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { seleccionar_CuentaContable, cargar_indicadorCCosto } from '../../actions/contabilidad/act_busquedaCtaContable';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { obtenerSecuencial } from '../../funciones_globales/parametros';

const ContenedorBotonAdd = styled.div`
	padding-top: 17px;  
	@media (max-width: 991px) {
	padding-top: 0px;
	}
`;

const ModalContainer = styled.div`
	margin-top: 20px;
	height: 400px;
	width: 410px;
`;

const Hr = styled.hr`
	margin-top: 10px;
	margin-bottom: 10px;
`;

const LabelCabecera = styled.label`
	display: inline;
	font-size: 10px;
	color: green;
	margin-right: 15px;
	float: right;
	margin-top: 3px;
`;

const Button = styled.button.attrs({className: "btn btn-default"})`
	margin-top:23px;
	font-size: 11px;
	height: 25px;
	padding: 0px 10px;
`;

class FormCon01 extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			//Usuario cambio willy
            userInput: "",
            passInput: "",
			usuario_aprobador: '',
			super: 'N',
			accion: 'G',
			fecha: null,
			usuario: '',
			comprobante: '',
			descripcion: '',
			asiento: '',

			tiposAsientos_Busq: [],
			tipoAsiento_selBusq: null,
			comprobante_Busq: '',

			debitoCredito: 'D',
			valor: '',
			detalle: '',
			isModalCCostoVisible: false,
			estadosAsiento: [],
			estados: [
				{
					label: 'Activo',
					value: 'P'
				},
				{
					label: 'Anulado',
					value: 'A'
				}
			],
			estado_Sel: 'P',
			tiposAsientos: [],
			tipoAsiento_sel: 'DI',
			indicadorTipoAsiento: 'M',
			ult_transaccion: null,
			detAsiento: [],
			totalDebe: 0,
			totalHaber: 0,
			columnDefs: [
				{   header: "No.",
					field: "NroItem",
					width: 35,
					type: "string",
					suppressFilter: true
				},
				{   header: "Cuenta",
					field: "Cuenta",
					width: 100,
					type: "string"
				},
				{   header: "Nombre Cuenta",
					field: "NombreCuenta",
					width: 200,
					type: "string"
				},
				{
					header: "D/H",
					field: "DebeHaber",
					width: 40,
					type: "string",
					editable: true,
					suppressFilter: true
				},
				{   header: "Débito",
					field: "Debito",
					width: 60,
					type: "num_decimal_edit",
					editable: true,
					suppressFilter: true
				},
				{   header: "Crédito",
					field: "Credito",
					width: 60,
					type: "num_decimal_edit",
					editable: true,
					suppressFilter: true
				},
				{   header: "Detalle",
					field: "Concepto",
					width: 210,
					type: "string",
					editable: true
				},
				{   header: "Centro Costo",
					field: "cc",
					width: 80,
					type: "num_decimal"
				}
			],
		}

		this.gridDetAsientoOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowSelection: "single",
			singleClickEdit: true,
			enableCellChangeFlash: true,
			onRowDoubleClicked: (event) => {
				this.setState({
					valor: (event.data.DebeHaber==="D"?event.data.Debito:event.data.Credito),
					detalle: event.data.Concepto,
					debitoCredito: event.data.DebeHaber
				});
				this.props.seleccionar_CuentaContable({
					key: 0, cuenta: {
					value: event.data.Cuenta,
					label: event.data.Cuenta + " (" + event.data.NombreCuenta.toUpperCase() + ")"
					}
				});

				let cuentaContable = this.gridDetComprobApi.getSelectedRows();
				let i;
				for( i = 0; i < this.state.detAsiento.length; i++ ){
					if( this.state.detAsiento[i].NroItem === cuentaContable[0].NroItem ){
					break;
					}
				}

				this.setState({detAsiento: this.deleteItemArray(this.state.detAsiento, i) }, () => this.mostarTotalesAsiento());
			},
			onCellEditingStarted: event => {
				if( event.column.colId === "Debito" && event.data.DebeHaber === "H" ) {
					this.gridDetComprobApi.stopEditing(true);					
				}

				if( event.column.colId === "Credito" && event.data.DebeHaber === "D" ) {
					this.gridDetComprobApi.stopEditing(true);
				}
			},
			onCellValueChanged: event => {
				let newValue = event.newValue.toString().trim();

				if( event.column.colId === "DebeHaber" ){
					if( !(newValue === "D" || newValue === "H") ) {
						event.data.DebeHaber = event.oldValue;
					}else{
					event.data.DebeHaber = newValue;

					if( newValue === "D" ){
						event.data.Debito = event.data.Credito;
						event.data.Credito = 0;
					}else{
						event.data.Credito = event.data.Debito;
						event.data.Debito = 0;
					}
					}
				}
				this.gridDetComprobApi.refreshCells();
				this.mostarTotalesAsiento();
			}
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.onGridReady = this.onGridReady.bind(this);
		this.limpiar = this.limpiar.bind(this);
		this.getAsientoById=this.getAsientoById.bind(this);
		this.agregarCuenta = this.agregarCuenta.bind(this);
		this.limpiarDetalle = this.limpiarDetalle.bind(this);
		this.eliminarCuenta = this.eliminarCuenta.bind(this);
		this.deleteItemArray = this.deleteItemArray.bind(this);
		this.grabarAsientoContable = this.grabarAsientoContable.bind(this);
		this.anularAsientoContable = this.anularAsientoContable.bind(this);
		this.handleChangeTipoAsiento = this.handleChangeTipoAsiento.bind(this);		
		this.imprimirAsiento = this.imprimirAsiento.bind(this);
		this.getAsientoByTipoComp = this.getAsientoByTipoComp.bind(this);
		this.mostarTotalesAsiento = this.mostarTotalesAsiento.bind(this);
		//WILLY 2019-09-17
		this.logIn = this.logIn.bind(this);
		this.changeUser = this.changeUser.bind(this);
		this.changePass = this.changePass.bind(this);
		this.clearAuth=this.clearAuth.bind(this)
	}
	//CAMBIO WILLY
	changeUser(event){

        event.preventDefault();
        const target = event.target;    
        const value = target.value;
        this.setState({userInput: value});
	}
	changePass(event){
        const target = event.target;    
        const value = target.value;
        this.setState({passInput: value});
	}
	//WILLY
	clearAuth(){
        this.setState({userInput: '', passInput: ''});
    }
	//WILLY
	authOperation(data){
        //Proceso Adquirir clave
        let config_request = {
            method: 'POST',
            url: '/validate/',
            data
        }

        return new Promise((resolve, reject) => {
            global_axios(config_request)
                .then((response)=>{
                    resolve(response.data);
                })
                .catch((error)=>{
                    reject(error);   
                })
            })
    }
	//CAMBIO DE WILLY
	logIn(){
		var data = {};
		console.log("EN LOGIN")
		console.log(this.props.formulario)
        data = { user: this.state.userInput, pass: this.state.passInput,
            codForm: this.props.formulario}
        if(this.state.userInput.length >0 && this.state.passInput.length >0){
			//Proceso Adquirir clave
			Promise.all([this.authOperation(data)])
			.then(([result_auth])=>{
				// Inicio de Sesión
				if(result_auth === true){
					alert("Acceso Realizado con exito")
					this.setState({super: 'S'})                                         
				}else{
					alert("Acceso denegado");
					this.clearAuth();
				}
			})
			.catch((error)=>{
				this.clearAuth();
				alert(error.response?error.response.data.msg:error.message);  
			});        
        }else{
            alert("Llenar los campos requeridos para solicitar autentificación")
        }
    }
  
	onGridReady(params) {
		this.gridDetComprobApi = params.api;
		this.gridDetComprobColumnApi = params.columnApi;
	}

	handleInputChange(event){
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});

		if(name==='descripcion'){
			this.setState({
				detalle: value
			});
		}
	}

	componentDidMount(){
		Promise.all([
			cargarCatalogos_OtrosConIndicador('TIPOASIENTO-IND'),
			cargarCatalogoEstados('ConMovimiento', 'Status'),
			obtenerSecuencial('ConMovimiento'),
			this.props.generar_LogAuditoriaIngresoForm('0801'),
		])
		.then(([tiposAsientos, estadosAsiento, secuencialConMvto]) => {
			let fechaProceso = getFechaProcesoPorModulo('08');
			this.setState({
				tiposAsientos,
				tiposAsientos_Busq: tiposAsientos,
				estadosAsiento,
				fecha: moment(fechaProceso, 'DD/MM/YYYY'),
				ult_transaccion: completar_String((secuencialConMvto.codigo - 1).toString(), '0', 7)
			});
		})
		.catch(error => {
			alert(error.response?error.response.data.msg:error);
		});
	}

	componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0801');
	}

	limpiar(){
		Promise.all([
			obtenerSecuencial('ConMovimiento'),
		])
		.then(([ secuencialConMvto ]) => {
			let fechaProceso = getFechaProcesoPorModulo('08');
			this.setState({
				accion: 'G',
				fecha: moment(fechaProceso,'DD/MM/YYYY'),
				usuario: '',
				descripcion: '',
				comprobante: '',

				tipoAsiento_selBusq: null,
				comprobante_Busq: '',

				asiento: '',
				debitoCredito: 'D',
				valor: '',
				detalle: '',
				isModalCCostoVisible: false,
				totalDebe: 0,
				totalHaber: 0,
				estados: [
					{
						label: 'Activo',
						value: 'P'
					},
					{
						label: 'Anulado',
						value: 'A'
					}
				],
				estado_Sel: 'P',
				tipoAsiento_sel: 'DI',
				indicadorTipoAsiento: 'M',
				detAsiento: [],
				super:'N',
				userInput:'',
				passInput:'',
				ult_transaccion: completar_String((secuencialConMvto.codigo - 1).toString(), '0', 7)
			});
		})
		.catch(error => {
			alert(error.response?error.response.data.msg:error);
		});

		this.props.seleccionar_CuentaContable({key: 0, cuenta: null});
		this.props.cargar_indicadorCCosto("0");
	}

	limpiarDetalle(){
		this.props.seleccionar_CuentaContable({key: 0, cuenta: null});
		this.setState({
			valor: '',
			debitoCredito: 'D',
			detalle: this.state.descripcion
		});
	}

	handleChangeTipoAsiento(value){
		let _validate = (value===null || value===undefined);

		this.setState({
			tipoAsiento_sel: _validate ? null : value.value,
			indicadorTipoAsiento: _validate ? null: value.indicador,
			super:'N',
			userInput:'',
			passInput:''
		});
		console.log(value)
	}

	handleChangeTipoAsiento_Busq(value){
		let _validate = (value===null || value===undefined);

		this.setState({
			tipoAsiento_selBusq: _validate ? null : value.value			
		});
	}

	getAsientoById(){
		let asiento = this.state.asiento;

		if( asiento ){
			this.props.cargarAsiento(asiento).then(
				() => {
					if (validarJSON(this.props.asientoContable)){
						let detAsiento = [];
						this.props.asientoContable.detAsiento.forEach((itemAsiento, i) => {
							let isDebe = itemAsiento.DebeHaber==="D";
							detAsiento.push({
								...itemAsiento,
								NroItem: (i+1),
								Debito: parseFloat(isDebe?itemAsiento.Valor:0).toFixed(2),
								Credito: parseFloat(!isDebe?itemAsiento.Valor:0).toFixed(2)
							});
						});

						this.setState({
							accion: 'M',
							estado_Sel: this.props.asientoContable.Status,
							usuario: this.props.asientoContable.Usuario,
							detAsiento,
							tipoAsiento_sel: this.props.asientoContable.Tipo,
							fecha: moment(this.props.asientoContable.Fecha,'YYYY-MM-DD'),
							comprobante: this.props.asientoContable.Comprobante,
							descripcion: this.props.asientoContable.Descripcion
						}, () => this.mostarTotalesAsiento());

						let _objTipoAsiendo = null;
						this.state.tiposAsientos.forEach(item => {
							if(item.value === this.state.tipoAsiento_sel){
								_objTipoAsiendo =  item;
								return;
							}
						});
						this.reactSelect.props.func_onChange(_objTipoAsiendo);
					}
				}
			);
		}else{
			alert("El campo número de asiento no ha sido especificado");
		}
	}

	getAsientoByTipoComp(){
		let tipo = this.state.tipoAsiento_selBusq;
		let comprobante = this.state.comprobante_Busq;

		if(!validarCampoString(tipo, 2, 3)){
			alert('No ha especificado el Tipo de Comprobante a consultar.');
			return;
		}

		if(!validarCampoString(comprobante, 1, 10)){
			alert('No ha especificado el No. de Comprobante a consultar.');
			return;
		}

		let qs = "?tipo="+tipo+"&comprobante="+comprobante;

		this.props.cambiar_VisualizacionLoading(true);
		global_axios({
			method: 'GET',
			url: '/diarios/' + qs
		})
		.then( response => {
			this.props.cambiar_VisualizacionLoading(false);

			let asientoContable = response.data;
			let detAsiento = [];
			asientoContable.detAsiento.forEach((itemAsiento, i) => {
				let isDebe = itemAsiento.DebeHaber==="D";
				detAsiento.push({
					...itemAsiento,
					NroItem: (i+1),
					Debito: parseFloat(isDebe?itemAsiento.Valor:0).toFixed(2),
					Credito: parseFloat(!isDebe?itemAsiento.Valor:0).toFixed(2)
				});
			});

			this.setState({
				accion: 'M',
				asiento: asientoContable.Movimiento,
				estado_Sel: asientoContable.Status,
				usuario: asientoContable.Usuario,
				detAsiento,
				tipoAsiento_sel: asientoContable.Tipo,
				fecha: moment(asientoContable.Fecha,'YYYY-MM-DD'),
				comprobante: asientoContable.Comprobante,
				descripcion: this.props.asientoContable.Descripcion
			});

			let _objTipoAsiendo = null;
			this.state.tiposAsientos.forEach(item => {
				if(item.value === this.state.tipoAsiento_sel){
					_objTipoAsiendo =  item;
					return;
				}
			});
			this.reactSelect.props.func_onChange(_objTipoAsiendo);
		})
		.catch( error => {
			this.props.cambiar_VisualizacionLoading(false);
      		alert(error.response?error.response.data.msg:error.message);
		});
	}

	agregarCuenta(){
		if( !this.props.cuentaContable_sel || (!this.props.cuentaContable_sel.value) ) {
			alert("Debe especificar una cuenta contable.");
			return;
		}

		if(!esNumero(this.state.valor)) {
			alert("El valor que ha ingresado es incorrecto.");
			return;
		}else{
			if(parseFloat(this.state.valor)<=0){
				alert("El valor que ha ingresado es incorrecto.");
				return;
			}
		}

		if( !this.state.detalle.trim().length ){
			alert("Debe especificar el detalle de la cuenta.");
			return;
		}

		let detAsiento = this.state.detAsiento.slice();
		let NroItem = this.state.detAsiento.length + 1;
		let isDebe = (this.state.debitoCredito==="D");
		let nombreCuenta = this.props.cuentaContable_sel.label.split("(")[1].split(")")[0];

		detAsiento.push({
			NroItem: NroItem,
			Cuenta: this.props.cuentaContable_sel.value,
			NombreCuenta: nombreCuenta,
			DebeHaber: (isDebe?"D":"H"),
			Debito: parseFloat(isDebe?this.state.valor:0).toFixed(2),
			Credito: parseFloat(!isDebe?this.state.valor:0).toFixed(2),
			Concepto: this.state.detalle.toUpperCase(),
			cc: ""
		});

		this.setState({detAsiento}, () => this.mostarTotalesAsiento());

		this.limpiarDetalle();
	}

	mostarTotalesAsiento(){
		let totalDebe = 0;
		let totalHaber = 0;

		this.state.detAsiento.forEach(item => {
			totalDebe = parseFloat(totalDebe) + parseFloat(item.Debito);
			totalHaber = parseFloat(totalHaber) + parseFloat(item.Credito);
		});

		//Redondear totales
		totalDebe = Math.round(totalDebe * 100) / 100;
		totalHaber = Math.round(totalHaber * 100) / 100;

		this.setState({
			totalDebe: totalDebe,
			totalHaber: totalHaber
		});
	}

	deleteItemArray (arr, index) {
		let indice = parseInt(index, 10);
		let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
		arr_tmp.forEach((item, i )=> item.NroItem = (i + 1));
		return arr_tmp;
	}

	eliminarCuenta(){
		let cuentaContable = this.gridDetComprobApi.getSelectedRows();

		if( !cuentaContable.length ){
			alert('Debe de seleccionar una cuenta contable.');
			return;
		}

		if( !window.confirm(`¿Está seguro de eliminar la cuenta: ${cuentaContable[0].Cuenta} (${cuentaContable[0].NombreCuenta})?`) ){
			return;
		}

		let i;
		for( i = 0; i < this.state.detAsiento.length; i++ ){
			if( this.state.detAsiento[i].NroItem === cuentaContable[0].NroItem ){
				break;
			}
		}

		this.setState({detAsiento: this.deleteItemArray(this.state.detAsiento, i) }, () => this.mostarTotalesAsiento());
	}

	grabarAsientoContable(){
		if( !this.state.tipoAsiento_sel ){
			alert("Debe seleccionar el tipo de asiento.");
			return;
		}

		if( this.state.descripcion.toString().trim() === '' ){
			alert("Debe especificar una descripción.");
			return;
		}

		if( !this.state.detAsiento.length ){
			alert("No ha especificado el detalle del asiento.");
			return;
		}

		if(this.state.accion === 'M'){
			if	(this.state.estado_Sel === 'A'){
				alert("No se puede modificar un asiento que está ANULADO.")
				return;
			}
		}

		let _permiso = this.props.permiso;

		let validPermiso = validarPermisoAcceso(this.state.accion, _permiso);
		if (!validPermiso.esValido){
			alert(validPermiso.msg);
			return;
		}

		let fechaProceso = getFechaProcesoPorModulo('08');
		if (this.props.permiteCambioFProceso==='S'){
			let validFProceso = validarFechaTransaccionSeleccionada(this.state.fecha, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);

			if(!validFProceso.esValida){
				alert(validFProceso.msg);
				return;
			}
		}

		let totalDebe = 0;
		let totalHaber = 0;
		let estado = "";

		this.state.detAsiento.forEach(item => {
			totalDebe = parseFloat(totalDebe) + parseFloat(item.Debito);
			totalHaber = parseFloat(totalHaber) + parseFloat(item.Credito);
		});

		//Redondear totales
		totalDebe = Math.round(totalDebe * 100) / 100;
		totalHaber = Math.round(totalHaber * 100) / 100;
		
		if ( totalDebe !== totalHaber ){
			alert("El asiento está descuadrado, por favor revisar.");
			return;
		}else{
			estado = "P";
		}

		let dataAsientoContable = {
			Tipo: this.state.tipoAsiento_sel, 
			Fecha: formatearFechaMoment_a_String(this.state.fecha),
			Comprobante: this.state.comprobante, 
			Descripcion: this.state.descripcion,
			Valor: parseFloat(parseFloat(this.state.detAsiento[0].Credito)===0?this.state.detAsiento[0].Debito:this.state.detAsiento[0].Credito).toFixed(2),
			Diferencia: (parseFloat(totalDebe) - parseFloat(totalHaber)),
			Usuario: getItemDatosSesion('usuario').toString(),
			Status: estado, 
			Moneda:  JSON.parse(getItemDatosSesion('moneda')).Moneda,
			Dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
			PlanVigente: getItemDatosSesion('planVigente')
		};

		let detalleAsiento = [];
		this.state.detAsiento.forEach(item => {
			detalleAsiento.push({
				Cuenta: item.Cuenta,
				Concepto: item.Concepto,
				Valor: parseFloat((parseFloat(item.Credito)===0?item.Debito:item.Credito)).toFixed(2),
				DebeHaber: (parseFloat(item.Credito)===0?"D":"H"),
				PlanCuenta: getItemDatosSesion('planVigente')
			});
		});

		dataAsientoContable.detalle = detalleAsiento;

		this.props.cambiar_VisualizacionLoading(true);

		global_axios({
			method: (this.state.accion==='M'?'PUT':'POST'),
			url: (this.state.accion==='M'?'/diarios/' + this.state.asiento:'/diarios'),
			data: dataAsientoContable
		})
		.then( response => {
			this.props.cambiar_VisualizacionLoading(false);
			this.setState({				
				comprobante: response.data.NroComprobante
			});
			alert("Se ha " + (this.state.accion==='M'?"modificado":"guardado") + " el asiento contable.");
			this.limpiar();
		})
		.catch( error => {
			this.props.cambiar_VisualizacionLoading(false);
      		alert(error.response?error.response.data.msg:error.message);
		});
	}

	anularAsientoContable(){
		let asiento = this.state.asiento.trim();

		if( this.state.indicadorTipoAsiento !== "M" ){
			alert("Solo se pueden anular asientos manuales.");
			return;
		}

		if( asiento ){
			if (!window.confirm("¿Está seguro de anular el asiento?")){
				return;
			}
			this.props.cambiar_VisualizacionLoading(true);
			global_axios({
				method: 'DELETE',
				url: '/diarios/' + asiento
			})
			.then( response => {
				this.props.cambiar_VisualizacionLoading(false);
				alert(response.data.msg);
				this.limpiar();
			})
			.catch( error => {
				this.props.cambiar_VisualizacionLoading(false);
      			alert(error.response?error.response.data.msg:error.message);
			});
		}else{
			alert("El número de asiento que va a anular no ha sido especificado.");
		}
	}	

	imprimirAsiento(){
		let NroMovimiento = this.state.asiento;
		visualizarReporteEnPdf('&rpt=27&param1=' + NroMovimiento);
	}
	 
	render(){
		return(      
			<ContenedorForm porc_ancho={60}>
				<HeaderForm>
					<TituloForm>Registro de asientos contables</TituloForm>
					<LabelCabecera>Usuario: {this.state.usuario}</LabelCabecera>
					<LabelCabecera>N°. comprob.: {this.state.comprobante}</LabelCabecera> 
					<LabelCabecera>Ult. asiento: {this.state.ult_transaccion}</LabelCabecera>
				</HeaderForm>        
				<CuerpoForm>
					<Row>
						<ContainerCol className='col-sm-3'>
							<LabelForm>Asiento:</LabelForm>
							<InputSearch
								tipoInput='text'
								nombre='asiento'
								placeholder='No. asiento'
								valor={this.state.asiento}
								func_CambiarValor={this.handleInputChange}
								func_BuscarValor={this.getAsientoById}
								func_OnFocus={()=>{this.limpiar()}}
							/>              
						</ContainerCol>

						<ContainerCol className='col-sm-4'>
							<LabelForm>Tipo asiento:</LabelForm>
							<ReactSelect
								options={ this.state.tiposAsientos_Busq }
								value={this.state.tipoAsiento_selBusq}
								ref={(select) => { this.reactSelect = select }}
								func_onChange={(value) => {this.handleChangeTipoAsiento_Busq(value)}}
							/>
						</ContainerCol>

						<ContainerCol className="col-sm-3">
							<LabelForm>No. Comprobante:</LabelForm>
							<InputText
								placeholder='No. Comprobante'
								name="comprobante_Busq"
								value={this.state.comprobante_Busq}
								onChange={this.handleInputChange}
							/>
						</ContainerCol>

						<ContainerCol className="col-sm-2">
							<Button onClick={this.getAsientoByTipoComp}>
								<i className="fa fa-search"></i>
							</Button>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className='col-sm-12'><hr /></ContainerCol>
					</Row>

					<Row>
						<ContainerCol className='col-sm-4'>
							<LabelForm>Tipo asiento:</LabelForm>
							<ReactSelect
								options={ this.state.tiposAsientos }
								value={this.state.tipoAsiento_sel}
								ref={(select) => { this.reactSelect = select }}
								func_onChange={(value) => {this.handleChangeTipoAsiento(value)}}
							/>
						</ContainerCol>
			
						<ContainerCol className='col-sm-2'>
							<LabelForm>Fecha:</LabelForm>
							<PickerFecha fechaSeleccionada={this.state.fecha} func_onChange={(fecha)=>{this.setState({fecha})}} disabled={!(this.props.permiteCambioFProceso==='S')}/>
						</ContainerCol>

						<ContainerCol className='col-sm-2'>
							<LabelForm>Estado:</LabelForm>
							<ReactSelect options={ this.state.estadosAsiento } disabled={true} value={this.state.estado_Sel} func_onChange={estado_Sel => this.setState({estado_Sel: estado_Sel.value})} />
						</ContainerCol>

						<ContainerCol className='col-sm-2'>
							<LabelForm>Total Debe</LabelForm>
							<InputText
								value={parseFloat(this.state.totalDebe).toFixed(2)}
								type="number"
								disabled={true}
							/>
						</ContainerCol>

						<ContainerCol className='col-sm-2'>
							<LabelForm>Total Haber</LabelForm>
							<InputText
								value={parseFloat(this.state.totalHaber).toFixed(2)}
								type="number"
								disabled={true}
							/>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className="col-sm-12">
							<LabelForm>Descripción:</LabelForm>
							<InputText
								placeholder='Ingrese una descripción del asiento'
								name="descripcion"
								value={this.state.descripcion}
								onChange={this.handleInputChange}
								autoComplete='off'
								maxLength='80'
							/>
						</ContainerCol>
					</Row>
					<Row margen_arriba={15}>					
						<ContainerCol className='col-sm-4'>
							<LabelForm className='radio-inline'>
								<input type="radio" name="debitoCredito" value="D" checked={this.state.debitoCredito==="D"} onChange={this.handleInputChange} />
								Débito
							</LabelForm>
							<LabelForm className='radio-inline'>
								<input type="radio" name="debitoCredito" value="H" checked={this.state.debitoCredito==="H"} onChange={this.handleInputChange} />
								Crédito
							</LabelForm>
						</ContainerCol>
					</Row>
					
					<Row>
						<ContainerCol className='col-sm-6'>
							<LabelForm>Cuenta:</LabelForm>
							<BusquedaCtaContable id={0} planVigente={getItemDatosSesion('planVigente')}></BusquedaCtaContable>
						</ContainerCol>
						{
							(this.state.tipoAsiento_sel !== 'DI')?
							<div>
								<ContainerCol className='col-md-2'>
									<LabelForm>Usuario:</LabelForm>
									<InputText name='usuario' type="text" value={this.state.userInput}  className='form-control input-sm' placeholder='user' onChange={this.changeUser}/>
								</ContainerCol>
								<ContainerCol className='col-md-2'>
									<LabelForm>Contraseña:</LabelForm>
									<InputText name='password'  type="password" value={this.state.passInput} className='form-control input-sm' onChange={this.changePass}/>
								</ContainerCol>
								<ContainerCol className='col-md-1' margen_arriba={15}>
									<button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.logIn}><i className="fa fa-key"></i> Aceptar</button>
								</ContainerCol>
							</div>
						:null
						}
						
					</Row>
					
					<Row>
						<ContainerCol className='col-sm-2'>
							<LabelForm>Valor:</LabelForm>
							<InputText
								placeholder='$ 00.00'
								name="valor"
								value={this.state.valor}
								onChange={this.handleInputChange}
								type="number"
							/>
						</ContainerCol>
						<ContainerCol className='col-sm-5'>
							<LabelForm>Detalle:</LabelForm>
							<InputText placeholder='Escriba el detalle de la cuenta' name='detalle' value={this.state.detalle}
								autoComplete='off' onChange={this.handleInputChange}/>
						</ContainerCol>

						<ContainerCol className='col-sm-2'>
							<br />
							<button className='btn btn-primary btn-sm' disabled={this.props.indicadorCCosto==="0"} onClick={() => {this.setState({isModalCCostoVisible: true})}}><i className='fa fa-tags'></i> C.C.</button>
						</ContainerCol>

						<ContainerCol className='col-sm-3'>
							<ContenedorBotonAdd>
								<div className='btn-group pull-left'> 
									<button type='button' className='btn btn-success btn-sm' onClick={this.agregarCuenta} disabled={this.state.indicadorTipoAsiento==='A' && this.state.super==='N'}><i className='fa fa-plus'></i></button>                
									<button type='button' className='btn btn-danger btn-sm' onClick={this.eliminarCuenta} disabled={this.state.indicadorTipoAsiento==='A' && this.state.super==='N'}><i className='fa fa-window-close'></i></button>
								</div>
							</ContenedorBotonAdd> 
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className='col-sm-12'>
							<AgGridRender
								altura='250px'
								data={this.state.detAsiento}
								columnas={this.state.columnDefs}
								gridOptions={this.gridDetAsientoOptions}
								onGridReady={this.onGridReady}
							/>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className='col-sm-12'>
							<LabelNota>* Doble click en la fila para editar los datos.</LabelNota>
							<LabelNota>* Un click en los campos D/H, Débito, Crédito y Detalle para editar.</LabelNota>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className="col-sm-12">
							<div className="btn-group btn-group-sm" role="group" aria-label="...">
								<button type="button" className="btn btn-primary" disabled={this.state.indicadorTipoAsiento==='A' && this.state.super==='N'} onClick={this.grabarAsientoContable}>
									<i className="fa fa-save fa-fw"></i>
									{this.state.accion==='M'?'Modificar':'Guardar'}
								</button>
								<button type="button" className="btn btn-default" onClick={this.limpiar}>
									<i className="fa fa-trash fa-fw"></i>Limpiar
								</button>
								<button className="btn btn-default" onClick={this.imprimirAsiento}>
									<i className="fa fa-print fa-fw"></i>Imprimir
								</button>
								<button className="btn btn-danger" onClick={this.anularAsientoContable}>
									<i className="fa fa-minus-circle fa-fw"></i>Anular
								</button>
							</div>
						</ContainerCol>
					</Row>
				</CuerpoForm>

				<ModalResponsive open={this.state.isModalCCostoVisible} onClose={()=>{this.setState({isModalCCostoVisible:false})}}>
					<ModalContainer>
						<Row>
							<div className='col-sm-12'>
								<h4>Centros de costos</h4>
								<Hr />
							</div>
						</Row>
						<Row>
							<div className='col-sm-12'>
								<div className="btn-group pull-right">
									<button type='button' className='btn btn-primary btn-sm'><i className='fa fa-check fa-lg'></i> Seleccionar</button>                    
									<button type='button' className='btn btn-danger btn-sm' onClick={() => this.setState({isModalCCostoVisible: false})}><i className='fa fa-times-circle fa-lg'></i> Cerrar</button>                                                
								</div>
							</div>
						</Row>  
					</ModalContainer>
				</ModalResponsive>
			</ContenedorForm>
		);
	}
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading, 
		permiso: state.sesion.valoresSesionForm.Permiso,
		asientoContable: state.contabilidad.asientoContable,
		cuentaContable_sel: state.contabilidad.cuentasContables_sel[0]===undefined?null:state.contabilidad.cuentasContables_sel[0].cuenta,
		indicadorCCosto: state.contabilidad.indicadorCCosto,
		permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
		diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
		formulario: state.sesion.valoresSesionForm.Formulario,
	};
});

const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cargarAsiento,
		cargar_indicadorCCosto,
		seleccionar_CuentaContable,
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaSalidaForm,
		generar_LogAuditoriaIngresoForm,
	}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCon01);